import clsx from 'clsx';
import { ArrowUp, ArrowDown } from 'lucide-react';

/**
 * Stat — single KPI metric: label, big value, optional trend.
 *
 * Props:
 *   label, value — required
 *   trend        - optional trend text ("12%", "+22%")
 *   trendDir     - "up" (default) | "down"
 *   tone         - "success" (default) | "danger" | "neutral"
 */
const TONES = {
  success: 'text-success',
  danger:  'text-danger',
  neutral: 'text-muted',
};

export function Stat({ label, value, trend, trendDir = 'up', tone = 'success', className = '' }) {
  return (
    <div className={clsx(
      'font-sans bg-page border border-soft rounded-lg px-4 py-3',
      className,
    )}>
      <div className="text-2xs font-semibold tracking-wider uppercase text-tertiary">{label}</div>
      <div className="text-[22px] font-bold text-ink leading-none mt-1 tracking-tight">{value}</div>
      {trend && (
        <span className={clsx(
          'inline-flex items-center gap-0.5 text-2xs font-semibold mt-1',
          TONES[tone],
        )}>
          {trendDir === 'up'
            ? <ArrowUp size={9} />
            : <ArrowDown size={9} />}
          {trend}
        </span>
      )}
    </div>
  );
}
